import { render } from "./TooltipButtonInfo.vue?vue&type=template&id=2bcc2c23&scoped=true"
import script from "./TooltipButtonInfo.vue?vue&type=script&lang=js"
export * from "./TooltipButtonInfo.vue?vue&type=script&lang=js"

import "./TooltipButtonInfo.vue?vue&type=style&index=0&id=2bcc2c23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcc2c23"]])

export default __exports__